/**
 * Latest Carro List
 */
 const latestCarData = [
  {
      verified_btn: 'Usado',
      btn: "",
      btn_color: "",
      image: "assets/img/car-finder/single/gallery/variedade_carros.png",
      year: '2019',
      title: "A maior variedade de carros",
      titleKey: "home.reason1Title",
      captionKey: "home.reason1Body",
      price: "$37,900",
      country: "New York",
      avg: "16",
      eng: "Automático2",
      fuel: "Gasolina",
      homeCardCaption:
        'Encontre o carro ideal para alugar, perfeitamente alinhado ao seu estilo de vida, às suas necessidades e ao tipo de viagem que você deseja fazer, garantindo conforto, praticidade e uma experiência incrível em cada trajeto.',
  },
  {
    verified_btn: 'Usado',
    btn: "Certificado",
    btn_color: "bg-success",
    image: "assets/img/car-finder/single/gallery/parcerias_velz.png",
    year: '2017',
    title: "Parcerias Velz",
    titleKey: "home.reason2Title",
    captionKey: "home.reason2Body",
    price: "$26,950",
    country: "Kansas",
    avg: "34",
    eng: "Manual",
    fuel: "Diesel",
    homeCardCaption:
      'Aproveite descontos exclusivos ao alugar seu carro com nossos parceiros, garantindo economia, praticidade e as melhores condições para tornar sua experiência ainda mais vantajosa e confortável.',
  },
  {
    verified_btn: 'Usado',
    btn: "",
    btn_color: "",
    image: "assets/img/car-finder/single/gallery/somos_empresa_b.png",
    year: '2019',
    title: "Excelência em Locação no Mato Grosso",
    titleKey: "home.reason3Title",
    captionKey: "home.reason3Body",
    price: "$29,700",
    country: "Los Angeles",
    avg: "18",
    eng: "Manual",
    fuel: "Gasolina",
    homeCardCaption:
      'A Velz é referência em locação de veículos em Mato Grosso, destacando-se pela excelência no atendimento, frota de qualidade e confiança em cada locação.',
  },
  {
    verified_btn: 'Usado',
    btn: "",
    btn_color: "",
    image: "assets/img/car-finder/catalog/02.jpg",
    year: '2018',
    title: "Mercedes Benz C300 Sport",
    price: "$53,600",
    country: "San Francisco",
    avg: "35",
    eng: "Automático",
    fuel: "Híbrido",
    homeCardCaption: 'Imagem alinhada ao seu negócio e frota dimensionada ao que você realmente precisa, com possibilidade de troca ou upgrade conforme a operação cresce.'
  },
];

/** Três razões fixas para a home (seção “Razões para alugar na Velz”) */
const rentalReasonsCards = latestCarData.slice(0, 3);

/**
 * Latest Notícias Data List
 */
 const newsData = [
  {
    image: "assets/img/car-finder/blog/04.jpg",
    sub_title: "Events",
    title: "Topo 10 Classic Carro Events",
    profile: 'assets/img/avatars/08.jpg',
    name: 'Jacob Jones',
    date: 'May 8',
    comments: "Sem comentários"
  },
  {
    image: "assets/img/car-finder/blog/05.jpg",
    sub_title: "Inspiration",
    title: "5 previsões do passado sobre o futuro",
    profile: 'assets/img/avatars/09.jpg',
    name: 'Guy Hawkins',
    date: 'Apr 25',
    comments: "6"
  },
  {
    image: "assets/img/car-finder/blog/06.jpg",
    sub_title: "Test Drives",
    title: "Este ano é todo sobre a nova Harley Davidson",
    profile: 'assets/img/avatars/12.jpg',
    name: 'Ralph Edwards',
    date: '12 mar',
    comments: "2"
  },
];



export { latestCarData, newsData, rentalReasonsCards };
